import HeaderBar from './header-bar.vue'
export default HeaderBar



// WEBPACK FOOTER //
// ./src/components/main/components/header-bar/index.js